// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeHubApi = class EdgeHubApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param getAccountRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async hubV1GetAccount(getAccountRequestModel, xProgramId) {
        const _url_ = '/edge/hub/v1/GetAccount';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getAccountRequestModel' is not null or undefined
        if (getAccountRequestModel === null || getAccountRequestModel === undefined) {
            throw new Error('Required parameter getAccountRequestModel was null or undefined when calling hubV1GetAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getAccountRequestModel, "GetAccountRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1GetAccountDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param getPatientRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async hubV1GetPatient(getPatientRequestModel, xProgramId) {
        const _url_ = '/edge/hub/v1/GetPatient';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getPatientRequestModel' is not null or undefined
        if (getPatientRequestModel === null || getPatientRequestModel === undefined) {
            throw new Error('Required parameter getPatientRequestModel was null or undefined when calling hubV1GetPatient.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getPatientRequestModel, "GetPatientRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1GetPatientDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param savePatientRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async hubV1SavePatient(savePatientRequestModel, xProgramId) {
        const _url_ = '/edge/hub/v1/SavePatient';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'savePatientRequestModel' is not null or undefined
        if (savePatientRequestModel === null || savePatientRequestModel === undefined) {
            throw new Error('Required parameter savePatientRequestModel was null or undefined when calling hubV1SavePatient.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(savePatientRequestModel, "SavePatientRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1SavePatientDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param hubSearchAccountsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async hubV1SearchAccounts(hubSearchAccountsRequestModel, xProgramId) {
        const _url_ = '/edge/hub/v1/SearchAccounts';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'hubSearchAccountsRequestModel' is not null or undefined
        if (hubSearchAccountsRequestModel === null || hubSearchAccountsRequestModel === undefined) {
            throw new Error('Required parameter hubSearchAccountsRequestModel was null or undefined when calling hubV1SearchAccounts.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(hubSearchAccountsRequestModel, "HubSearchAccountsRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1SearchAccountsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param searchPatientsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async hubV1SearchPatients(searchPatientsRequestModel, xProgramId) {
        const _url_ = '/edge/hub/v1/SearchPatients';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'searchPatientsRequestModel' is not null or undefined
        if (searchPatientsRequestModel === null || searchPatientsRequestModel === undefined) {
            throw new Error('Required parameter searchPatientsRequestModel was null or undefined when calling hubV1SearchPatients.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(searchPatientsRequestModel, "SearchPatientsRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1SearchPatientsDefaultResponse");
        }
        return response;
    }
};
EdgeHubApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeHubApi);
export { EdgeHubApi };
//# sourceMappingURL=edgeHubApi.js.map